<template>
  <div>
    <Header />
    <div class="information">
      <div class="intro mb30">
        <img :src="'/' + item.product_image_path + item.image_stre_file_name" alt="">
        <h2 class="title title--h2 mt40" v-if="!!item.product_det_name">
          {{item.product_det_name}}
        </h2>
        <h2 class="title title--h2 mt40" v-else>
          {{item.brand_product_name}}
        </h2>
      </div>
      <div class="description-section">
        <template v-if="isQr">
          <template v-if="item.product_code && item.gcct_no">
            <img v-if="isLocal" :src="require(`@/assets/${item.product_image_path}qr/${item.brand_code}/${item.product_code}/${item.gcct_no}.png`)">
            <img v-else :src="`/${item.product_image_path}qr/${item.brand_code}/${item.product_code}/${item.gcct_no}.png`">
          </template>
        </template>
        <template v-else>
          <h2 class="title title--h2 title--bg">바코드</h2>
          <template v-if="!isErrorLoadingBarcodeImage && item.pin && item.rqst_no">
            <img v-if="isLocal" :src="require(`@/assets/${item.product_image_path}barcode_images/${item.rqst_no}/${item.pin}.jpg`)">
            <img v-else :src="`/${item.product_image_path}barcode_images/${item.rqst_no}/${item.pin}.jpg`" @error="imageLoadError">
          </template>
          <template v-else-if="item.gcct_no">
            <div class="barcode-wrap">
              <vue-barcode :value="item.gcct_no" :text="getGcctNoWithDash(item.gcct_no)" format="CODE128" height="80" font-size="15" />
            </div>
          </template>
        </template>
      </div>
      <div class="description-section">
        <h2 class="title title--h2 title--bg">상품 상세 정보</h2>
        <div v-html="item.product_det_bdt" class="data-inner"></div>
      </div>
      <div class="information-section mt40">
        <h2 class="title title--h2 title--bg">
          환불규정 및 유의사항
        </h2>
        <!-- <div v-html="item.rfnd_rgln_use_desc_bdt" class="data-inner"></div> -->
        <div class="data-inner">
          <div v-if="item.rfnd_rgln_use_desc_bdt" class="info-group">
            <strong>환불규정 및 유의사항</strong>
            <div v-html="item.rfnd_rgln_use_desc_bdt"></div>
          </div>
          <div  v-if="item.xcg_bhf_bdt" class="info-group">
            <strong>교환지점안내</strong>
            <div v-html="item.xcg_bhf_bdt"></div>
          </div>
          <div v-if="item.add_words_bdt" class="info-group">
            <strong>추가문구</strong>
            <div v-html="item.add_words_bdt"></div>
          </div>
        </div>
      </div>
      <div class="contact mt60">
        <div class="contact__row">
          <div class="contact__column contact__column--title">
            발행자
          </div>
          <div class="contact__column contact__column--contents">
            기프티엘
          </div>
        </div>
        <div class="contact__row">
          <div class="scontact__column contact__column--title">
            고객센터
          </div>
          <div class="contact__column contact__column--contents">
            1644-4276
          </div>
        </div>
      </div>
      <div class="image-box" v-html="item.ad_bdt">
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header';
import axios from 'axios';
import _ from 'lodash';
import VueBarcode from 'vue-barcode';

const endPoint = process.env.ENDPOINT;

export default {
  name: 'Information',
  components: {
    Header,
    VueBarcode
  },
  data() {
    return {
      isErrorLoadingBarcodeImage: false,
      item: {
        product_det_name: '',
        brand_product_name: '',
        product_det_bdt: '',
        image_orgnl_file_name: '',
        image_stre_file_name: '',
        image_file_byte: '',
        product_image_path: '',
        pin: '',
        rqst_no: '',
        gcct_no: '',
        send_type_code: '',
        rfnd_rgln_use_desc_bdt: '',
        xcg_bhf_bdt: '',
        add_words_bdt: '',
        ad_bdt: '',
        brand_code: '',
        product_code: ''
      }
    };
  },
  computed: {
    isLocal() {
      return endPoint.includes('localhost') || endPoint.includes('127.0.0.1');
    },
    isTestSendType() {
      return this.item.send_type_code === '000000';
    },
    isQr() { // QR 상품인지 확인
      return this.item.send_type_code === '000006';
    }
  },
  created() {
    const key = this.$route.params.key;
    const url = `${process.env.ENDPOINT}/detail/${key}`;
    axios.get(url).then(this.setData);
  },
  methods: {
    imageLoadError() {
      this.isErrorLoadingBarcodeImage = true;
    },
    setData(res) {
      if (res.status === 200) {
        const data1 = this.getData1(res);
        console.log(data1);
        const data2 = this.getData2(res);
        console.log(data2);
        this.item = Object.assign({}, data1, data2);
      }
    },
    getData1(res) {
      const data = res.data.response.data1;
      if (!data) {
        return {};
      }
      const toPickProps = [
        'product_det_name', 'brand_product_name', 'product_det_bdt', 'image_orgnl_file_name', 'image_stre_file_name', 'image_file_byte',
        'product_image_path', 'pin', 'rqst_no', 'gcct_no', 'send_type_code', 'product_code', 'brand_code'
      ];
      return _.pick(data, toPickProps);
    },
    getData2(res) {
      const data = res.data.response.data2;
      if (!data) {
        return {};
      }
      const toPickProps = ['rfnd_rgln_use_desc_bdt', 'xcg_bhf_bdt', 'add_words_bdt', 'ad_bdt'];
      return _.pick(data, toPickProps);
    },
    getGcctNoWithDash(gcctNo) {
      if (!gcctNo) {
        return;
      }
      const length = gcctNo.length;
      if (length > 12) {
        return `${gcctNo.substring(0, 4)}-${gcctNo.substring(4, 8)}-${gcctNo.substring(8, 12)}-${gcctNo.substring(12)}`;
      } else if (length > 8) {
        return `${gcctNo.substring(0, 4)}-${gcctNo.substring(4, 8)}-${gcctNo.substring(8)}`;
      }
      return gcctNo;
    }
  }
};
</script>
<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
.information {
  width: 100%;
  margin: 0 auto;
  color: #666;
  letter-spacing: -0.5px;
  box-shadow: 0px 8px 14px -5px #e5e5e5 inset;

  h2{
    line-height: 24px;
  }
  .intro {
    text-align: center;
    padding: 20px 20px 0;
  }
  .contact {
    background-color: #f5f5f5;
    padding: 15px 20px;
    &__row {
      @include flexbox();
      @include align-items(center);
      &:nth-child(2) {
        margin-top: calc(15px - 5px);
      }
    }
    &__column {
      &--title {
        width: 72px;
        font-size: 12px;
      }
      &--contents {
        width: calc(100% - 72px);
        font-size: 14px;
        color: #222;
      }
    }
  }
  .barcode-wrap {
    text-align: center
  }
}
img {
  width: 100%;
}

.data-inner {
  padding: 20px;
}
.title {
  color: #222;
  padding: 0 20px;
  &--h2 {
    font-size: 16px;
    font-weight: 500;
  }
  &--h3 {
    font-size: 14px;
  }
  &--bg {
    background-color: #eee;
    padding: 12.5px 20px;
  }
}
.description {
  font-size: 14px;
  padding: 0 20px;
  line-height: 21px;
  &--color-defalut {
    color: #222;
  }
  &--line-height-48 {
    line-height: 24px;
    margin-top: -2.5px;
    &:nth-child(2) {
      margin-top: 0px;
    }
  }
}
.bullet-point {
  display: table-cell;
  &--pr5 {
    padding-right: 2.5px;
  }
}
.info-group{
  strong{
    display:block;
    font-size:14px;
    color:#222;
  }
  & ~ .info-group{
    margin:20px 0 0 0;
  }
}
.mt20 {
  margin-top: calc(10px - 7.5px); // line-height 값 제거
}
.mt40 {
  margin-top: 20px;
}
.mt60 {
  margin-top: 30px;
}
.mb30 {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Info.vue